import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";

const GateScreen = () => {

    return (
        <Box>
            <Outlet />
        </Box>
    )
}

export default GateScreen